import { useTranslation } from "@/i18n";
import { useConfigStore } from "@store/index";

export const useTb = () => {
  const { t } = useTranslation();
  const { config } = useConfigStore();

  const brand = (() => {
    const odBrand = config?.contactLensesData?.OD?.product?.description?.[0]?.brand;
    const osBrand = config?.contactLensesData?.OS?.product?.description?.[0]?.brand;
    const brands = [...new Set([odBrand, osBrand].filter(Boolean))] as string[];
    return brands
      .map((str) => str.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase()))
      .join(" & ");
  })();

  return (key: string) => t(key).replace(/{{brand}}/g, brand);
};
